/* eslint-disable no-param-reassign */
import * as DOM from './js/utils';
import extendBaseLayerControl from './js/extendBaseLayerControl';
import extendMessageControl from './js/extendMessageControl';
import extendDisplayLayerControl from './js/extendDisplayLayerControl';
import Dawa from './js/dawa';

class App {
    constructor(leaflet, config, document, window) {
        if (!leaflet) {
            throw new Error('Leaflet not loaded');
        }
        if (!config) {
            throw new Error('Config not loaded');
        }
        this._elements = {
            interface: DOM.createElement('div', { id: 'interface' }),
            map: DOM.createElement('div', { id: 'map' }),
        };
        this.config = config;
        this.state = {
            lastClick: false,
            baseLayersGroup: null,
            overlayLayersGroup: null,
            selectedDisplayLayer: null,
            baseLayers: [],
            overlayLayers: [],
            displayLayers: [],
        };
        this.version = '1.3.0';
        this.controls = [
            leaflet.control.scale({
                position: 'bottomleft',
                imperial: false,
                metric: true,
            }),
            leaflet.control.zoom({
                position: 'bottomright',
            }),
        ];
        this._addBaseLayerControl = extendBaseLayerControl;
        this._addDisplayLayerControl = extendDisplayLayerControl;
        this._addMessageControl = extendMessageControl;
        this.init = () => {
            document.body.appendChild(this._elements.interface);
            document.body.appendChild(this._elements.map);
            const mapOptions = {
                doubleClickZoom: false,
                zoomControl: false,
                center: [56.23, 11.25],
                maxZoom: 19,
                minZoom: 7,
                zoom: 7,
            };
            if (DOM.getQueryString().integrated === 'true') {
                mapOptions.gestureHandling = true;
            }
            if (config.maxZoom) {
                mapOptions.maxZoom = config.maxZoom;
            }
            if (config.minZoom) {
                mapOptions.minZoom = config.minZoom;
            }
            if (config.initialZoom) {
                mapOptions.zoom = config.initialZoom;
            }
            if (config.initialCenter) {
                mapOptions.center = config.initialCenter;
            }
            if (leaflet.Browser.ie || leaflet.Browser.ielt9) {
                mapOptions.preferCanvas = false;
            }
            const startCenter = DOM.getQueryString().center;
            if (startCenter) {
                const coords = startCenter.split(',').map((str) => Number(str));
                mapOptions.center = coords;
            }
            const startZoom = DOM.getQueryString().zoom;
            if (startZoom) {
                const zoom = Number(startZoom);
                mapOptions.zoom = zoom;
            }
            this.map = leaflet.map('map', mapOptions);
            this.controls.forEach((control) => control.addTo(this.map));
            this.search = new Dawa(
                this._elements.interface,
                this.map,
                this.config.search,
            );
            this._addBaseLayerControl.call(this, leaflet);
            this._addMessageControl.call(this, this._elements.interface);
            const ticketCookie = DOM.getCookie('ticket');
            const geolocation_prompt = DOM.getQueryString().geolocation_prompt;
            if (geolocation_prompt == undefined || geolocation_prompt === 'true') {
                document.querySelector('.geofinder').click(); // Zoom to location on start
            }
            // const ticketCookie = false;
            if (ticketCookie) {
                window.config.ticket = ticketCookie;
                this._addDisplayLayerControl.call(this, leaflet);
            } else {
                DOM.get(this.config.connections.ticket, (requestError, response) => {
                    if (requestError) {
                        throw new Error('Could not get a ticket!', requestError);
                    }
                    window.config.ticket = response.replace(/"/g, '');
                    DOM.setCookie('ticket', window.config.ticket, 12); // 12 hours
                    this._addDisplayLayerControl.call(this, leaflet);
                });
            }
        };
    }
}

window.app = new App(window.L, window.config, document, window);
window.onload = (() => window.app.init())();
